export const actType = [
  { value: 1, label: '获客' },
  { value: 2, label: '促答' },
  { value: 3, label: '运营' },
  { value: 4, label: '品牌' }
];

export default {

};
